import { render, staticRenderFns } from "./ApprovalTable.vue?vue&type=template&id=3d6c38af&scoped=true&"
import script from "./ApprovalTable.vue?vue&type=script&lang=js&"
export * from "./ApprovalTable.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalTable.vue?vue&type=style&index=0&id=3d6c38af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c38af",
  null
  
)

export default component.exports